import { render, staticRenderFns } from "./OragnisationEdit.vue?vue&type=template&id=60acb212&scoped=true"
import script from "./OragnisationEdit.vue?vue&type=script&lang=js"
export * from "./OragnisationEdit.vue?vue&type=script&lang=js"
import style0 from "./OragnisationEdit.vue?vue&type=style&index=0&id=60acb212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acb212",
  null
  
)

export default component.exports